import IDocSection from "../../models/IDocSection";
import { IDocLocation } from "../../functions/getLocationInfo";
import { getCurrentDocMenuItem } from "../../functions/getCurrentDocMenuItem";

const getSection = (doc?: IDocLocation): IDocSection => {
  const docMenu = getCurrentDocMenuItem();
  if (docMenu) {
    return docMenu.item.docSection;
  }
  return { section: "Guides", headerMenu: [] };
};

export default getSection;
